import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/StateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
import { getDataByUrl } from "@/handlers/commonApi";
import useIsMobile from "@/hooks/useIsMobile";
import OldElectionScreen from "@/screens/OldStateElection";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  faqData = null,
  constituencyListData = null,
}) {
  const isMobileDevice = useIsMobile();
 let metaData = {
  title: `Haryana Assembly Election 2024 FAQs:हरियाणा विधानसभा चुनाव 2024 से संबंधित पूछे जाने वाले प्रश्न - Newstak`,
  description: `Haryana Assembly Election FAQs: Get answers to all your questions about हरियाणा विधानसभा चुनाव 2024 at NewsTak.in | हरियाणा विधानसभा चुनाव से संबंधित सभी सवालों के जवाब पाएं.`,
  keywords: `Haryana Assembly Election 2024 FAQs, election frequently asked questions, voting process 2024, eligibility criteria for voters, Haryana election dates and timelines, Haryana Assembly elections guide, Haryana voter registration, Haryana election polling information, Haryana election help, हरियाणा विधानसभा चुनाव 2024 से संबंधित सवाल`
};


  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <OldElectionScreen
          categoryNewsListData={categoryNewsListData}
          faqData={faqData}
          // electionPath={"delhi-assembly/schedule"}
          electionPath={`/faqs`}  
          masterKey="haryana_election"
          isMobileDevice={isMobileDevice}
          electionPassedCategory={'haryana-assembly'} //'delhi-assembly'
          stateName={"Haryana"} //"Delhi"
          stateHindi={"हरियाणा"} //"महाराष्ट्र"
          metaData={metaData}
          constituencyListData={constituencyListData}
           
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  let url = ctx?.resolvedUrl;
  url = url.split("/faqs")[0];

  let electionCategory = url
 
  try {
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getFaqBySlug } = await import("@/handlers/faq");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let masterConfigData = await getMasterConfig();

    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    let faqRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticpages", url: "assembly-election-faq" },
    });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

 let electionConfigData = null;
    const electionConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.bihar_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2020
        ? electionConfigData?.allConstituency2020Api
        : electionConfigData?.allConstituency2025Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    });

    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,
       faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(faqRedisKey, () =>
        getFaqBySlug({
          url: "assembly-election-faq",
        })
      ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory: electionCategory,
        faqData,
        constituencyListData
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
